import * as React from 'react';
import { createComponent } from '@lit/react';
import { UniversalNavWC } from './universal-nav.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../components/component-types-generics';

export type UniversalNavProps =
  GenerateComponentTypeWithChildren<UniversalNavWC> & {
    onProjectSelect?: ({
      detail: { selection },
    }: {
      detail: { selection: string | null };
    }) => void;
  };

export type UniversalNavPropsWithRef = GeneratePropsWithRef<UniversalNavProps>;

export const UniversalNav = createComponent({
  tagName: UniversalNavWC.tagname,
  elementClass: UniversalNavWC,
  react: React,
  events: {
    onProjectSelect: 'project-select',
  },
}) as UniversalNavPropsWithRef;
